import React from "react";

const defaultImprovementRows = [
  {
    nicCode: "",
    productName: "",
    turnoverPercentage: "",
    assessmentBoundary: "",
    conductedByExternalAgency: "",
    resultPublicDomain: "",
  },
];

const ImprovementImpactTable1 = ({ improvementData1, setImprovementData1 }) => {
  const handleChange = (index, field, value) => {
    const updated = [...improvementData1];
    updated[index][field] = value;
    setImprovementData1(updated);
  };

  const addRow = () => {
    setImprovementData1([
      ...improvementData1,
      {
        nicCode: "",
        productName: "",
        turnoverPercentage: "",
        assessmentBoundary: "",
        conductedByExternalAgency: "",
        resultPublicDomain: "",
      },
    ]);
  };

  const removeRow = () => {
    if (improvementData1.length > 1) {
      setImprovementData1(improvementData1.slice(0, -1));
    }
  };

  return (
    <div>
      <div
        style={{
          marginTop: "20px",
          overflowX: "auto",
          overflow: "hidden",
          borderRadius: "8px",
          border: "1px solid #000",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            borderRadius: "8px",
            border: "1px solid #000",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
              <th style={tableHeaderStyle}>S. No</th>
              <th style={tableHeaderStyle}>NIC Code</th>
              <th style={tableHeaderStyle}>Name of Product/Service</th>
              <th style={tableHeaderStyle}>% of total Turnover contributed</th>
              <th style={tableHeaderStyle}>
                Boundary for which the Life Cycle Perspective / Assessment was
                conducted
              </th>
              <th style={tableHeaderStyle}>
                Whether conducted by independent external agency (Yes/No)
              </th>
              <th style={tableHeaderStyle}>
                Results communicated in public domain (Yes/No) <br /> If yes,
                provide the web-link.
              </th>
            </tr>
          </thead>
          <tbody>
            {improvementData1.map((row, index) => (
              <tr key={index}>
                <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                  {index + 1}.
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    placeholder="NIC Code"
                    value={row.nicCode}
                    onChange={(e) =>
                      handleChange(index, "nicCode", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    placeholder="Product/Service"
                    value={row.productName}
                    onChange={(e) =>
                      handleChange(index, "productName", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="number"
                    placeholder="% Turnover"
                    value={row.turnoverPercentage}
                    onChange={(e) =>
                      handleChange(index, "turnoverPercentage", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <textarea
                    placeholder="Assessment Boundary"
                    value={row.assessmentBoundary}
                    onChange={(e) =>
                      handleChange(index, "assessmentBoundary", e.target.value)
                    }
                    style={textareaStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    placeholder="Yes / No"
                    value={row.conductedByExternalAgency}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "conductedByExternalAgency",
                        e.target.value
                      )
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <textarea
                    placeholder="Yes / No / Web-link"
                    value={row.resultPublicDomain}
                    onChange={(e) =>
                      handleChange(index, "resultPublicDomain", e.target.value)
                    }
                    style={textareaStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={buttonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={buttonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  textAlign: "center",
  outline: "none",
};

const textareaStyle = {
  width: "100%",
  height: "80px",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
  resize: "vertical",
};

const buttonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default ImprovementImpactTable1;
